import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';

export const eshopUserToolsRefresh = () => {
  execute({
    target: [ 'userLists'],
    url: `/qf/${window.projectConfig.lang}/ramjet/include`,
    updatedCart: true,
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/eshopUserToolsRefresh.js